<template>
  <div>
    <ComponenteSolicitacaoHistorico
      :chave-externa="chaveExterna"
      :funcionalidade="funcionalidade"
      :lista-externa="listaExterna"
      :lista-interna="listaInterna"
    >
      <template v-slot:externo="{card}">
        <slot
          :card="card"
        />
      </template>

      <template v-slot:interno="{card}">
        <div
          @click="detalhe(card)"
        >
          <ListaStatusCard
            :card="card"
            :showWidgetActions="showWidgetActions"
          />
        </div>
      </template>
    </ComponenteSolicitacaoHistorico>
  </div>
</template>

<script>
import ListaStatusCard from '@/components/TemplateSolicitacao/componentes/ListaStatusCard'
import { mapGetters, mapState } from 'vuex'
import ComponenteSolicitacaoHistorico from '@/components/TemplateSolicitacao/componentes/ComponenteSolicitacaoHistorico'
import { EnumCanalAtendimentoOrigem } from '@/constants/EnumCanalAtendimentoOrigem'

export default {
  name: 'SolicitacaoHistorico',
  components: { ComponenteSolicitacaoHistorico, ListaStatusCard },
  props: {
    funcionalidade: {
      type: Object,
      default: () => ({})
    },
    listaExterna: {
      type: Array,
      default: () => []
    },
    chaveExterna: {
      type: String,
      default: ''
    },
    rotaDetalhe: {
      type: String,
      defalut: ''
    }
  },
  data () {
    return {
      listaInterna: []
    }
  },
  computed: {
    ...mapState('SetupApp', ['apiSolicitacao']),
    ...mapGetters('SetupApp', ['canalAtendimentoOrigem']),
    showWidgetActions () {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return true
        default:
          return false
      }
    }
  },
  methods: {
    async init () {
      await this.getList()
    },
    detalhe (card) {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return false
        default:
          return this.$router.push({
            path: this.rotaDetalhe,
            query: {
              idOcorrencia: card['id_ocorrencia']
            }
          })
      }
    },
    async getList () {
      const data = new Date()
      data.setMonth(data.getMonth() - 6)
      const response = await this.apiSolicitacao.solicitacao({
        headers: {
          id_funcionalidade: this.funcionalidade.idFuncionalidade,
          data_inicial: data.getTime(),
          data_final: new Date().getTime()
        },
        loading: true,
        handlerErrorIgnore: true
      })

      this.listaInterna = response.data.contratos
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style scoped>

</style>
